import Modal from "components/blocks/Modal";
import RichTextEditor from "components/RichTextEditor";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CreateCourseRequest } from "services/courseService/models/CourseType";

type CourseTemplateEditorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSave: (content: { ar: string; en: string }) => void;
  content: CreateCourseRequest["courseDetails"];
  fieldName: "ruleAndConditionTemplate" | "commitmentTemplate";
};

const CourseTemplateEditorModal: React.FC<CourseTemplateEditorModalProps> = ({
  isOpen,
  onClose,
  onSave,
  content,
  fieldName,
}) => {
  const { t } = useTranslation("Courses");
  const [editorContent, setEditorContent] = useState({
    ar: content.find((x) => x.locale === "Ar")?.[fieldName] ?? "",
    en: content.find((x) => x.locale === "En")?.[fieldName] ?? "",
  });

  const onArEditorContentChange = (text: string) => {
    setEditorContent((prev) => ({ ...prev, ar: text }));
  };

  const onEnEditorContentChange = (text: string) => {
    setEditorContent((prev) => ({ ...prev, en: text }));
  };

  const onSaveClicked = () => {
    onSave(editorContent);
    onClose();
  };

  return (
    <Modal
      fullscreen
      isOpen={isOpen}
      onClose={onClose}
      title={t("editForm")}
      footer={
        <div className="d-flex justify-content-end gap-3">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            {t("Common:cancel")}
          </button>
          <button type="button" className="btn btn-primary" onClick={onSaveClicked}>
            {t("Common:save")}
          </button>
        </div>
      }
    >
      <div className="row">
        <div className="col-6">
          <h5>عربي</h5>
          <RichTextEditor initialData={editorContent.ar} onChange={onArEditorContentChange} />
        </div>
        <div className="col-6">
          <h5>English</h5>
          <RichTextEditor initialData={editorContent.en} onChange={onEnEditorContentChange} />
        </div>
      </div>
    </Modal>
  );
};

export default CourseTemplateEditorModal;
